import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Star, CheckCircle, Quote, ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { apiRequest } from '../lib/utils';

function StarsRow({ rating }) {
    return (
        <div className="flex gap-0.5">
            {[1, 2, 3, 4, 5].map((n) => (
                <Star key={n} className={`h-4 w-4 ${n <= rating ? 'fill-amber-400 text-amber-400' : 'text-muted-foreground/30'}`} />
            ))}
        </div>
    );
}

export default function FeaturedReviews() {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        apiRequest('/site-reviews/featured?limit=4')
            .then((d) => setReviews(d.reviews || []))
            .catch(() => setReviews([]))
            .finally(() => setLoading(false));
    }, []);

    if (loading || reviews.length === 0) return null;

    return (
        <section className="py-16 px-4 sm:px-6 lg:px-8" data-testid="featured-reviews-section">
            <div className="max-w-6xl mx-auto">
                <div className="text-center mb-10">
                    <Badge className="mb-3 bg-amber-500/10 text-amber-600 border-amber-500/30">
                        <Star className="h-3 w-3 fill-amber-500 text-amber-500 mr-1" />
                        Ils nous recommandent
                    </Badge>
                    <h2 className="font-heading text-3xl sm:text-4xl font-bold mb-3">Ce que disent nos clients</h2>
                    <p className="text-muted-foreground max-w-xl mx-auto">
                        Des avis sincères de propriétaires de piscine du Var
                    </p>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {reviews.map((r) => (
                        <Card key={r.review_id} className="glass rounded-2xl hover:shadow-lg transition" data-testid={`featured-review-${r.review_id}`}>
                            <CardContent className="p-5 flex flex-col h-full">
                                <Quote className="h-6 w-6 text-primary/40 mb-2" />
                                <StarsRow rating={r.rating} />
                                <h3 className="font-semibold mt-2 mb-2 text-sm">{r.title}</h3>
                                <p className="text-xs text-muted-foreground flex-1 line-clamp-4">{r.comment}</p>
                                <div className="flex items-center justify-between text-xs pt-3 mt-3 border-t border-border">
                                    <div className="flex items-center gap-2">
                                        <div className="h-7 w-7 rounded-full bg-primary/10 flex items-center justify-center text-primary text-xs font-semibold">
                                            {(r.author_name || 'C')[0].toUpperCase()}
                                        </div>
                                        <span className="font-medium text-foreground">{r.author_name}</span>
                                    </div>
                                    {r.verified && (
                                        <CheckCircle className="h-4 w-4 text-emerald-500" />
                                    )}
                                </div>
                            </CardContent>
                        </Card>
                    ))}
                </div>

                <div className="text-center mt-8">
                    <Link to="/avis">
                        <Button variant="outline" className="rounded-full gap-2">
                            Voir tous les avis
                            <ArrowRight className="h-4 w-4" />
                        </Button>
                    </Link>
                </div>
            </div>
        </section>
    );
}
